module.exports = __webpack_public_path__ + "img/kakao.7c418a22.svg";